export class CalendarEvent {
    id: number = -1;

    calendarId: number = -1;
    name: string = '';
    date: string = '';
    startTime: string = '';
    endTime: string = '';
    isFullDay: boolean = false;
    description: string = '';
    createdAt: string = '';
    updatedAt: string = '';
}